module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-prize-03-ff966d1a394483c1bf03ff94a55465af.svg";